import {PROFILE_UPDATE_REQUEST, PROFILE_UPDATE_FAILURE, PROFILE_UPDATE_SUCCESS, PROFILE_RESET_UPDATED} from './constants';

export function updateProfile (data) {
    return {
        type: PROFILE_UPDATE_REQUEST,
        data
    }
}

export function getProfileUpdateSuccessAction (data) {
    return {
        type: PROFILE_UPDATE_SUCCESS,
        data
    }
}

export function getProfileUpdateFailureAction (data) {
    return {
        type: PROFILE_UPDATE_FAILURE,
        error: data.error
    }
}

export function resetUpdated () {
    return {
        type: PROFILE_RESET_UPDATED
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Profile/actions.js